export const ButtonTestIdFactory = {
    getButtonBase: () => 'button',
    getCustomButtonBase: () => ['custom', ButtonTestIdFactory.getButtonBase()].join('-'),
    getButtonTestId: (testId) => [ButtonTestIdFactory.getButtonBase(), testId].join('-'),
    getButtonTextTestId: (testId) => [ButtonTestIdFactory.getButtonBase(), testId, 'text'].join('-'),
    getCustomButtonLabelTestId: (testId) => [ButtonTestIdFactory.getCustomButtonBase(), testId, 'label'].join('-'),
};
